import type { DocSection } from '../types'

/**
 * A role's sections, read (FR-47).
 *
 * Headings are shown as written, not upper-cased like the product's own
 * labels, because changing their case would be rewording them. Each line is
 * its own paragraph, because a line can be a list item or a whole paragraph
 * and nothing here can tell which.
 */
export function SectionsView({ sections }: { sections: DocSection[] }) {
  if (!sections.length) {
    return <p className="hint">This job description has no text yet. Edit it to add some.</p>
  }
  return (
    <>
      {sections.map((s, i) => (
        <div className="section section--doc" key={i}>
          {s.heading && <h3>{s.heading}</h3>}
          {s.lines.length
            ? s.lines.map((line, j) => <p key={j}>{line}</p>)
            : <p className="hint">Nothing under this heading.</p>}
        </div>
      ))}
    </>
  )
}
